export const PRESETS = {
  primary: {
    from: '#002873',
    to: '#0044C2'
  },
  secondary: {
    from: '#2D9274',
    to: '#51B295'
  }
};